import { random } from "lodash";
import React, { FC } from "react";
import { StyleSheet, View, Text } from "react-native";
import FontStyles from "../../constants/FontStyle";

const randomColors = () => {
  const rgb = [];
  for (let i = 0; i < 3; i++) {
    rgb.push(Math.floor(random(0, 1, true) * 255));
  }
  rgb.push(0.2);
  return `rgba(${rgb.join(",")})`;
};

const getInitials = (text: string) => {
  const names = text ? text.split(" ") : [""];
  return (
    names[0].slice(0, 1) +
    `${names.length > 1 ? " " + names[1].slice(0, 1) : ""}`
  );
};

export const AvatarText: FC<{ title: string }> = ({ title }) => {
  return (
    <View style={[styles.container]}>
      <Text>{getInitials(title)}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: 40,
    height: 40,
    borderRadius: 40,
    backgroundColor: randomColors(),
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    ...FontStyles.medium,
    ...FontStyles.size16,
    ...FontStyles.lh20,
    alignSelf: "center",
  },
});
